import CreditCardPayment from './CreditCardPayment';

export default CreditCardPayment;